<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-thunder-bolt`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M27 8.35L12.809 23.79l10.169 1.937v13.195l13.434-16.18L27 21.29V8.35zm4 9.51l9.511 1.468a2 2 0 011.234 3.254L22.516 45.738a2 2 0 01-3.538-1.277V29.037L8.53 27.047a2 2 0 01-1.098-3.317L27.527 1.866A2 2 0 0131 3.219V17.86z"/></svg>
</template>
<script>

export default {
  name: 'IconThunderBolt',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
